<template>
  <div class="shipment-data">
    <div class="shipment-data-top">
      <!-- tab切换 -->
      <div class="switch-menu">
        <el-radio-group
          class="menu-name"
          v-for="(item, index) in menuList"
          :key="index"
          v-model="selectedTab"
          @change="toUrl(item.url)"
        >
          <el-radio-button :label="item.name"></el-radio-button>
        </el-radio-group>
      </div>

      <!-- 统计信息 -->
      <div class="search-container">
        <div class="statistics">
          <div
            v-for="(item,index) in statisticsList"
            :key="index"
            class="item-statistics"
          >
            <div class="item-statistics-content">
              <div>
                <p class="sub-title">{{item.title}}</p>
                <p class="sub-content">{{item.content}}</p>
              </div>
              <img class="statistics-img" :src="item.img" alt>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 发货数据列表 -->
    <div class="table shipment-table">
      <div class="search">
        <div class="search-left">
          <span class="search-left-title">仓库名称：</span>
          <el-select
            v-model="warehouseId"
            clearable
            placeholder="请选择仓库"
          >
            <el-option
              v-for="item in warehouseList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <span  class="search-left-title">日期：</span>
          <el-date-picker
            class="marginRight"
            v-model="date"
            type="date"
            value-format="yyyy-MM-dd"
            clearable
            placeholder="选择日期">
          </el-date-picker>
          <el-button icon="el-icon-search" class="btn-blue" @click="searchData">搜索</el-button>
          <el-button icon="el-icon-refresh" class="btn-gray" @click="reset">重置</el-button>
        </div>
        <div class="search-right" @click="openActualOrderNums">
          <span class="set-img"></span>
          <span>实际单量设置</span>
        </div>
      </div>
      <el-table :data="tableData" style="width: 100%" :header-cell-class-name="headerCellClassName">
        <el-table-column
          v-for="(item, index) in tableTitleList"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          show-overflow-tooltip
          :min-width="item.width"
          :class-name="item.alignment === 'right'?`cell-right-align-width`:''"
        ></el-table-column>
      </el-table>
      <div class="pagination">
        <pagination-tpl
          :total="total"
          :currentPage="currentPage"
          :pageSize="pageSize"
          @queryChange="queryChange"
        ></pagination-tpl>
      </div>
    </div>

    <!-- 实际单量设置 -->
    <el-drawer
      title="实际单量设置"
      width="960px"
      :wrapperClosable="false"
      :visible.sync="drawer"
      :before-close="handleCloseDrawer">
      <div class="drawer-content">
        <!-- 实际单量设置搜索 -->
        <div class="search">
          <div class="search-left">
            <span class="search-left-title">仓库名称：</span>
            <el-select
              v-model="actualWarehouseId"
              clearable
              placeholder="请选择仓库"
            >
              <el-option
                v-for="item in warehouseList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
            <span class="search-left-title">日期：</span>
            <el-date-picker
              class="marginRight"
              v-model="actualDate"
              type="date"
              value-format="yyyy-MM-dd"
              clearable
              placeholder="选择日期">
            </el-date-picker>
            <el-button class="btn-blue" @click="searchActualData">搜索</el-button>
          </div>
        </div>
        
        <!-- 实际单量设置列表 -->
        <div class="table">
          <el-table :data="tableActualList" style="width: 100%;">
            <el-table-column
              prop="projectName"
              label="项目名称"
            ></el-table-column>
            <el-table-column prop="actualOrderNums" label="实际单量">
              <template slot-scope="scope">
                <el-input
                  placeholder="请输入"
                  v-model="scope.row.actualOrderNums"
                  @input="inputActualOrderNums(scope.$index, scope.row.actualOrderNums)"
                  @blur="blurActualOrderNums(scope.row.id, scope.row.actualOrderNums)"
                ></el-input>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="drawer-footer">
        <el-button class="btn-gray" @click="handleCloseDrawer">取消</el-button>
        <el-button class="btn-blue" @click="confirm">保存</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { getInteger, formatTimeToDate, commafy } from "common/js/util";
import PaginationTpl from "components/base/PaginationTpl";
import ShipmentData from "models/shipment-data";
import Expenses from "models/expenses";
const expenses = new Expenses();
export default {
  components: {
    PaginationTpl,
  },

  data() {
    return {
      total: 0,
      currentPage: 1,
      pageSize: 20,
      // 发货数据列表
      tableData: [],
      tableTitleList: [
        {label: '项目名称', prop: 'projectName', width: '', alignment:'left'},
        {label: '截单时间', prop: 'cutOffTime', width: '', alignment:'left'},
        {label: '实际单量', prop: 'actualOrderNums', width: '', alignment:'right'},
        {label: '完成订单数', prop: 'finishOrderNums', width: '', alignment:'right'},
        {label: '未完成订单数', prop: 'incompleteOrderNums', width: '', alignment:'right'},
        {label: '完成率', prop: 'completionRate', width: '', alignment:'right'},
        {label: '完成总件数', prop: 'finishTotalNums', width: '', alignment:'right'},
        {label: '客单件均数', prop: 'singlePiece', width: '', alignment:'right'},
        {label: '同品订单数', prop: 'homologueOrderNums', width: '', alignment:'right'},
        {label: '同品件数', prop: 'homologueNums', width: '', alignment:'right'},
      ],
      // 发货数据搜索日期
      date: formatTimeToDate(new Date().getTime() - 60*60*24*1000),
      // 发货数据搜索仓库id
      warehouseId: '',
      warehouseList: [],
      // 统计信息集合
      statisticsList: [
        {title: '订单总数', content: 0, img: require('../../../../../assets/images/shipment-data/total-order-num.png')},
        {title: '完成订单数', content: 0, img: require('../../../../../assets/images/shipment-data/finish-order-num.png')},
        {title: '未完成订单数', content: 0, img: require('../../../../../assets/images/shipment-data/incomplete-order-num.png')},
        {title: '完成率', content: '0%', img: require('../../../../../assets/images/shipment-data/completion-rate.png')},
        {title: '完成总件数', content: 0, img: require('../../../../../assets/images/shipment-data/finish-total-num.png')},
        {title: '客单件均数', content: 0, img: require('../../../../../assets/images/shipment-data/single-piece.png')},
        {title: '同品订单数', content: 0, img: require('../../../../../assets/images/shipment-data/homologue-order-num.png')},
        {title: '同品件数', content: 0, img: require('../../../../../assets/images/shipment-data/homologue-num.png')},
      ],
      drawer: false,
      // 实际单量列表
      tableActualList: [],
      // 实际单量列表搜索仓库id
      actualWarehouseId: '',
      // 实际单量列表搜索日期
      actualDate: formatTimeToDate(new Date().getTime() - 60*60*24*1000),
      
      // tab切换列表
      menuList: [
        {name: '发货数据', url: '/home/production-data/shipment-data'},
        {name: '揽收数据', url: '/home/production-data/after-sale'}
      ],
      selectedTab: '发货数据'
    };
  },
  
  activated() {
    this.selectedTab = '发货数据'
  },

  async created() {
    await this.getWarehouse()
    this.initShipmentDataList();
    this.initShipmentStatisticsListList();
  },

  methods: {
    /**
     * @desc 获取统计信息
     */
    initShipmentStatisticsListList() {
      let date = this.date
      let warehouseId = this.warehouseId
      let data = {
        date,
        warehouseId
      }
      ShipmentData.getShipmentStatisticsListList(data).then(res => {
        if (res.success) {
          let { receiveOrderNum, finishOrderNum, notFinishOrderNum, finishRate, finishGoodsNum,
          finishGoodsNumByUnitOrderNum, hotOrderNum, hotGoodsNum } = res.result
          let completionRate = finishRate == '-' ? finishRate: `${finishRate}%`
          this.statisticsList = [
            {title: '订单总数', content: commafy(receiveOrderNum), img: require('../../../../../assets/images/shipment-data/total-order-num.png')},
            {title: '完成订单数', content: commafy(finishOrderNum), img: require('../../../../../assets/images/shipment-data/finish-order-num.png')},
            {title: '未完成订单数', content: commafy(notFinishOrderNum), img: require('../../../../../assets/images/shipment-data/incomplete-order-num.png')},
            {title: '完成率', content: completionRate, img: require('../../../../../assets/images/shipment-data/completion-rate.png')},
            {title: '完成总件数', content: commafy(finishGoodsNum), img: require('../../../../../assets/images/shipment-data/finish-total-num.png')},
            {title: '客单件均数', content: commafy(finishGoodsNumByUnitOrderNum), img: require('../../../../../assets/images/shipment-data/single-piece.png')},
            {title: '同品订单数', content: commafy(hotOrderNum), img: require('../../../../../assets/images/shipment-data/homologue-order-num.png')},
            {title: '同品件数', content: commafy(hotGoodsNum), img: require('../../../../../assets/images/shipment-data/homologue-num.png')},
          ]
        } else {
          this.$message.error(res.message)
        }
      })
    },

    /**
     * @desc 发货数据列表
     */
    initShipmentDataList() {
      let date = this.date
      let warehouseId = this.warehouseId
      let currentPage = this.currentPage
      let data = {
        date,
        currentPage,
        warehouseId
      }
      ShipmentData.getShipmentDataList(data).then(res => {
        if (res.success) {
          let arr = []
          this.total = res.result.totalNum
          this.pageSize = res.result.pageSize
          res.result.items.map(i => {
            let obj = {}
            obj.projectId = i.projectId
            obj.projectName = i.projectName
            obj.cutOffTime = i.finalOrderTime?i.finalOrderTime:0
            obj.actualOrderNums = commafy(i.receiveOrderNum)
            obj.finishOrderNums = commafy(i.finishOrderNum)
            obj.incompleteOrderNums = commafy(i.notFinishOrderNum)
            obj.completionRate = i.finishRate === '-'?i.finishRate:`${i.finishRate}%`
            obj.finishTotalNums = commafy(i.finishGoodsNum)
            obj.singlePiece = commafy(i.finishGoodsNumByUnitOrderNum)
            obj.homologueOrderNums = commafy(i.hotOrderNum)
            obj.homologueNums = commafy(i.hotGoodsNum)
            arr.push(obj)
          })
          this.tableData = arr
        } else {
          this.$message.error(res.message)
        }
      })
    },

    /**
     * @desc 实际单量设置列表
     */
    initActualList() {
      let date = this.actualDate
      let warehouseId = this.actualWarehouseId
      let data = {
        date,
        warehouseId
      }
      ShipmentData.getActualList(data).then(res => {
        if (res.success) {
          let arr = []
          res.result.map(i => {
            let obj = {}
            obj.id = i.projectId
            obj.projectName = i.projectName
            obj.actualOrderNums = i.receiveOrderNum
            arr.push(obj)
          })
          this.tableActualList = arr
        } else {
          this.$message.error(res.message)
        }
      })
    },

    /**
     * @desc 表头添加类名处理数字右对齐
     */
    headerCellClassName({ columnIndex}) {
      if (columnIndex > 1) {
        return 'right-align'
      }
    },
    
    /**
     * @desc 获取仓库数据
     */
    async getWarehouse() {
      let res = await expenses.getWarehouseData()
        if (res.success) {
          let arr = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.warehouseList = arr;
          this.warehouseId = arr.length > 0 ? arr[0].id : '';
          this.actualWarehouseId = arr.length > 0 ? arr[0].id : '';
        }
    },

    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initShipmentDataList();
    },

    reset() {
      this.date = "";
      this.warehouseId = "";
    },

    searchData() {
      if (!this.warehouseId) return this.$message.error('请选择仓库')
      if (!this.date) return this.$message.error('请选择日期')
      this.currentPage = 1;
      this.initShipmentDataList();
      this.initShipmentStatisticsListList();
    },

    /**
     * @desc 开启实际单量抽屉
     */
    async openActualOrderNums() {
      this.actualWarehouseId = await this.warehouseList.length > 0 ? this.warehouseList[0].id : '';
      this.actualDate = await formatTimeToDate(new Date().getTime() - 60*60*24*1000)
      await this.initActualList()
      this.drawer = true
    },

    searchActualData() {
      this.initActualList();
    },

    handleCloseDrawer() {
      this.actualDate = "";
      this.actualWarehouseId = "";
      this.drawer = false
      this.initShipmentDataList();
      this.initShipmentStatisticsListList();
    },

    confirm() {
      this.handleCloseDrawer()
    },
    
    /**
     * @desc 实际单量输入限制整数
     */
    inputActualOrderNums(index, price) {
      let actualOrderNums = getInteger(price);
      this.tableActualList[index].actualOrderNums = actualOrderNums;
    },

    blurActualOrderNums(projectId, receiveOrderNum) {
      let date = this.actualDate
      let data = {
        date,
        projectId,
        receiveOrderNum
      }
      ShipmentData.saveActualOrderNums(data).then(res => {
        if (!res.success) {
          this.$message.error(res.message)
        }
      })
    },

    toUrl(v) {
      this.$router.push({
        path: v,
      });
    }
  },
};
</script>

<style lang="scss">
@import '@/assets/style/layout/quality/shipmentData.scss';
</style>
